<template>
  <div class="main-content">
    <!-- Page Header Start -->
    <PageHeader :isAssessmentBarRemoved="true">
      <PageHeaderTitleContent>
        <TitleTextContent :titleText="cyberReadinessCheckToolTitle" />
        <router-link :to="{
          name: 'cyber-readiness-check',
        }">
          <v-btn rounded large dark width="240" :color="primaryButtonColor">
            Back to all
          </v-btn>
        </router-link>
      </PageHeaderTitleContent>
    </PageHeader>
    <!-- Page Header End -->
    <!-- Body Area Start-->
    <section class="section section-content p-0 mt-4 mb-4">
      <div class="container-fluid mb-5 my-3 px-3 px-lg-5 px-xl-5" v-if="isLoggedIn" style="min-height: 700px">
        <div v-if="showModal">
          <transition name="modal">
            <div class="modal-mask">
              <div class="modal-wrapper">
                <div class="modal-dialog" role="document">
                  <div class="modal-content">
                    <div class="modal-header">
                      <h6 class="modal-title">{{ this.titleText }}</h6>
                      <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true" @click="showModal = false">&times;</span>
                      </button>
                    </div>
                    <div class="modal-body">
                      <!--
                        <div style="position: relative; padding-top: 56.25%;"><iframe src="https://customer-vqtiuw508mb7y2yt.cloudflarestream.com/f51ffa427ced0bf4d02e63be7250a97d/iframe?autoplay=true&poster=https%3A%2F%2Fcustomer-vqtiuw508mb7y2yt.cloudflarestream.com%2Ff51ffa427ced0bf4d02e63be7250a97d%2Fthumbnails%2Fthumbnail.jpg%3Ftime%3D%26height%3D600&startTime=1m55s" style="border: none; position: absolute; top: 0; left: 0; height: 100%; width: 100%;" allow="accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture;" allowfullscreen="true"></iframe></div>
                         -->
                      <div style="position: relative; padding-top: 56.25%;"><iframe :src=videoURL
                          style="border: none; position: absolute; top: 0; left: 0; height: 100%; width: 100%;"
                          allow="accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture;"
                          allowfullscreen="true"></iframe></div>
                    </div>
                    <div class="modal-footer">
                      <button type="button" class="btn btn-secondary" @click="showModal = false">Close</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </transition>
        </div>
        <!-- surveySet - used to track when survey is ready to render -->
        <div v-if="surveySet" id="surveyContainer" class="row surveyDiv">
          <!-- If you want to hide survey, comment the lines below -->
          <survey :survey="survey"></survey>
        </div>
        <div class="pt-4 mt-4" v-show="isLoading">
          <b-spinner label="Loading..."></b-spinner>
        </div>

        <!-- <button @click="showModal = true">Click</button>
          <button id="show-modal" @click="showModal = true">Show Modal</button> -->
        <div v-show="isSurveyComplete && completeButtonClicked" id="surveyComplete" class="mt-4 pt-4">
          <h5 v-if="missingSecurityplan == false">Your Assessment is complete.</h5>
          <h5 v-if="missingSecurityplan == true">Your Assessment is incomplete because of the absence of a System
            Security Plan.</h5>
          <div class="row">
            <div class="pa-5 col-md-12">
              <!--  <v-app id="cyber"> -->
              <div class="pt-4" v-show="isNIST && !isScoping">
                <v-col cols="9">
                  <v-card elevation="4">
                    <v-card-text>
                      {{ completeText }}
                      Your score: <strong> {{ score }}/110 </strong>
                    </v-card-text>
                  </v-card>
                </v-col>
              </div>
              <v-col cols="9">
                <center>
                  <v-progress-circular v-show="isNIST && !isScoping" :rotate="180" :size="300" :width="60"
                    :value="score" color="blue-grey">
                    <h5>
                      <strong>{{ score }}/110</strong>
                    </h5>
                  </v-progress-circular>
                </center>
              </v-col>
              <div class="pt-4" v-show="!isNIST && !isScoping">
                <v-col cols="9">
                  <v-card elevation="4">
                    <v-card-text>
                      {{ completeText }}
                      Your score: <strong> {{ score }}% </strong>
                    </v-card-text>
                  </v-card>
                </v-col>
              </div>
              <v-col cols="9">
                <center>
                  <v-progress-circular v-show="!isNIST && !isScoping" :rotate="180" :size="300" :width="60"
                    :value="score" color="blue-grey">
                    <h6>{{ score }}%</h6>
                  </v-progress-circular>
                </center>
              </v-col>

              <div class="row mt-5 text-center" v-show="!isScoping">
                <div class="col-md-4 text-center">
                  <button type="button" @click="printAction" class="btn theme-btn rounded w-100">
                    Print Answers
                  </button>
                </div>
                <div class="col-md-4 text-center">
                  <download-csv class="" :data="surveyCSV" name="CyberReadiness.csv">
                    <button type="button" class="btn theme-btn rounded w-100">
                      Export to CSV
                    </button>
                  </download-csv>
                </div>
              </div>
              <div class="row mt-5">
                <div class="col-md-4 text-center">
                  <a href="/dashboard" class="btn theme-btn rounded w-100">
                    Go to Dashboard
                  </a>
                </div>
                <div class="col-md-4 text-center">
                  <button @click="reloadPage" type="button" class="btn theme-btn rounded w-100">
                    Back to Cyber Readiness Check
                  </button>
                </div>
              </div>
              <div id="printDiv"></div>
              <!-- </v-app> -->
            </div>
          </div>
        </div>
        <div v-show="isSurveyPartial && completeButtonClicked" id="surveyPartial" class="mt-4 pt-4">
          <h5>Your responses are saved.</h5>
          <div class="row">
            <div class="pa-5 col-md-8">
              <p class="pt-4"><strong>Progress: </strong></p>
              <v-app>
                <v-col cols="9">
                  <center>
                    <v-progress-linear :value="progress" color="cyan" height="25">
                      <template>
                        <strong>{{ progress }}%</strong>
                      </template>
                    </v-progress-linear>
                  </center>
                  <div class="row mt-4 pt-4">
                    <div class="col-md-6 text-center">
                      <a href="/dashboard" variant="link" class="btn theme-btn w-100 rounded centered-link">
                        Go to Dashboard
                      </a>
                    </div>
                    <div class="col-md-6 text-center">
                      <button @click="reloadPage" type="button" class="btn theme-btn rounded w-100">
                        Back to Cyber Readiness Check
                      </button>
                    </div>
                  </div>
                </v-col>
              </v-app>
            </div>
          </div>
        </div>
      </div>
      <div v-if="!isLoggedIn" class="container my-5 text-center">
        <br />Please
        <router-link :to="{ name: 'login', query: { redirect: this.location.hash } }">Login </router-link>
        or <router-link :to="{ name: 'signup' }">Register </router-link> as
        organization to take the Cyber Readiness Check.<br />
        <br />
      </div>
    </section>
  </div>
</template>

<script>
import * as SurveyVue from "survey-vue";
import axios from "axios";
import { isLoggedIn } from "../../utils/authentication";
import PageHeader from "../library/widgets/page-header.vue";
import PageHeaderTitleContent from "../library/widgets/page-header-title-content.vue";
import TitleTextContent from "../library/widgets/title-text-content.vue";
var Survey = SurveyVue.Survey;
let _this;
var questionNameTitleMap = {}; // this is used in view print assessment
var questionTotalCount = 0;
var subQuestionList = [];
export default {
  components: {
    Survey,
    PageHeader,
    PageHeaderTitleContent,
    TitleTextContent,
  },
  data() {
    return {
      survey: {},
      surveySet: false,
      isSurveyComplete: false,
      isSurveyPartial: false,
      completeButtonClicked: false,
      progress: 0,
      score: 0,
      isNIST: false,
      schema: {},
      surveyCSV: [],
      isLoading: false,
      completeText: '',
      showModal: false,
      videoURL: '',
      titleText: '',
      isScoping: (this.$route.params.toolKey.indexOf('SCOPING')) > 0 ? true : false,
      missingSecurityplan: false,
      cyberReadinessCheckData: {
        // NEWCMMCLEVEL1SCOPING: 'FCI - Discovery Questionnaire',
        NEWCMMCLEVEL1: 'CMMC Level 1 - Self-Assessment',
        // NEWCMMCLEVEL2SCOPING: 'CUI - Discovery Questionnaire',
        NEWCMMCLEVEL2: 'CMMC Level 2 - Self-Assessment',
        // NEWNIST800171: 'NIST 800-171',
      },
      cyberReadinessCheckToolTitle: null,
    };
  },
  props: {
    toolKey: {
      type: String,
    },
  },
  created() {
    // Check if the toolKey exists in cyberReadinessCheckData
    if (!this.cyberReadinessCheckData[this.$route.params.toolKey]) {
      // Redirect to cyber-readiness-check if toolKey is invalid
      this.$router.push({ name: 'cyber-readiness-check' });
      return;
    }
    this.getActiveAssessmentSchema(this.$route.params.toolKey);
    _this = this;
  },
  computed: {
    isLoggedIn() {
      return isLoggedIn();
    },
  },
  mounted() {
    this.init();
    // Add a native event listener to the Vue element.
    this.$el.addEventListener("click", this.onHtmlClick)
  },
  methods: {
    init() {
      /* The footer height no longer needs to be set */
      // this.initFooterHeight();

      this.cyberReadinessCheckToolTitle = this.cyberReadinessCheckData[this.$route.params.toolKey];
    },
    reloadPage() {
      window.location.reload();
    },
    onHtmlClick(event) {
      // Check to make sure this is from our v-html because
      // we don't want to handle clicks from other things in
      // the Vue
      if (!event.target.classList.contains("survey-video"))
        return;
      let videoDiv = event.target.getElementsByClassName('videoLink')
      this.videoURL = videoDiv[0].innerHTML.toString().replaceAll("&amp;", "&");
      let titleTextDiv = event.target.getElementsByClassName('titleText');
      this.titleText = titleTextDiv[0].innerHTML;
      event.stopPropagation();
      event.preventDefault();
      this.showModal = true;
    },
    geturl() {
      return "/#/cyber-readiness-check-tool/" + this.$route.params.toolKey
    },
    initFooterHeight() {
      var footerHeight = $("footer").outerHeight();
      $(".main-content").css("margin-bottom", footerHeight);
    },
    printAction() {
      var surveyAnswersDivText = document.getElementById("printDiv").outerHTML;
      var surveyAnswersWindow = window.open(
        "",
        "_blank",
        "width=800,height=800"
      );
      surveyAnswersWindow.focus();
      var doc = surveyAnswersWindow.document;
      doc.open();
      doc.write(surveyAnswersDivText);
      const script = doc.createElement("script");
      script.type = "text/javascript";
      script.src = "https://ajax.googleapis.com/ajax/libs/jquery/3.6.1/jquery.min.js";

      const script1 = doc.createElement("script");
      script1.type = "text/javascript";
      script1.src = "../../assets/js/print.js";

      doc.body.appendChild(script);
      doc.body.appendChild(script1);
      doc.close();
    },
    async getActiveAssessmentSchema(tool) {
      /*  API call to assessment/schema */
      axios
        .get("/api/assessment/schema/" + tool)
        .then((response) => {
          this.schema = response.data.schema;
          this.buildQuestionNameTitleMap(this.schema, tool);
          var json = response.data.schema;
          SurveyVue.StylesManager.applyTheme("winterstone");
          SurveyVue.Serializer.addProperty("question", "tooltip");
          SurveyVue.Serializer.addProperty("question", "videoLink");
          SurveyVue.Serializer.addProperty("question", "specialCase");
          //initialize surveyvue
          var survey = new SurveyVue.Model(json);
          if (tool != "NEWCMMCLEVEL1") {
            //TOOLTIP for questions
            survey.onAfterRenderQuestion.add(function (survey, options) {
              //Return if there is no description to show in popup
              var header = options.htmlElement.querySelector("h5");
              var headerSpan = header.querySelector(".sv-string-viewer");
              if (options.question.specialCase != null && options.question.specialCase != '') {

                var span = document.createElement("span");
                span.innerText = options.question.specialCase;
                span.className = "redText";
                var br = document.createElement("br");
                headerSpan.appendChild(br);
                headerSpan.appendChild(span);
              }

              if (options.question.tooltip != null && options.question.tooltip != '') {
                //header.title = options.question.tooltip;
                var bulb = document.createElement("i");
                bulb.className = "rightArrow";
                var anchor = document.createElement("div");
                anchor.innerText = "Tooltip";
                var span = document.createElement("span");
                span.innerText = options.question.tooltip;
                span.className = "right";
                var i = document.createElement("i");
                span.appendChild(i);
                anchor.className = "survey-tooltip";
                anchor.appendChild(span);
                var br = document.createElement("br");
                headerSpan.appendChild(br);
                headerSpan.appendChild(bulb);
                headerSpan.appendChild(anchor);
              }

              if (options.question.videoLink != null && options.question.videoLink != '') {
                var bulb = document.createElement("span");
                bulb.className = "leftLine";
                bulb.innerText = "|";
                var anchor = document.createElement("div");
                anchor.innerText = "Explainer Video";
                var span = document.createElement("span");
                //span.innerText = options.question.tooltip;
                span.className = "right";
                var i = document.createElement("i");
                span.appendChild(i);
                anchor.className = "survey-video";
                anchor.appendChild(span);
                var br = document.createElement("br");
                // headerSpan.appendChild(br);
                headerSpan.appendChild(bulb);
                headerSpan.appendChild(anchor);
                var videoLinkDiv = document.createElement("div")
                videoLinkDiv.innerText = options.question.videoLink;
                videoLinkDiv.className = "videoLink";
                var titleTextDiv = document.createElement("div")
                titleTextDiv.innerText = survey.currentPage.name + " " + options.question.name;
                titleTextDiv.className = "titleText";
                anchor.appendChild(videoLinkDiv);
                anchor.appendChild(titleTextDiv);
                videoLinkDiv.style.display = 'none';
                titleTextDiv.style.display = 'none'
                //anchor.title = options.question.survey-tooltip;
              }
            });
          }


          var surveyValueChanged = function (sender, options) {
            var el = document.getElementById(options.name);
            if (el) {
              el.value = options.value;
            }
          };
          survey.onValueChanged.add(surveyValueChanged);
          //Adding - comment section to questions -- get all visible questions
          // var questions = survey.getAllQuestions(true);
          // for (var i = questions.length - 1; i >= 0; i--) {
          //   var q = questions[i];
          //   //Make the current question read-only. We need to make enableIf property empty and set readOnly property to true
          //   // q.enableIf = "";
          //   // q.readOnly = true;
          //   //get question index in the container
          //   var index = q.parent.elements.indexOf(q);
          //   //Insert the comment question after the question
          //   var commentQuestion = q.parent.addNewQuestion("comment", "panel-" + q.name, index + 1);
          //   //Hide the location
          //   commentQuestion.titleLocation = "hidden";
          //   //Set comment the place holder
          //   commentQuestion.placeHolder = "Please comment about \"" + q.title + "\"";
          // }
          this.loadState(survey);
          //ON Survey complete
          survey.onComplete.add(function (survey) {
            _this.isLoading = true;
            _this.completeButtonClicked = true;
            _this.saveState(survey);
          });
          //ON partial complete
          survey.onPartialSend.add(function (survey) {
            _this.saveState(survey);
          });
          survey.showCompletedPage = false;
          this.survey = survey;
          this.surveySet = true;
          return {
            survey: this.survey,
          };
        })
        .catch((error) => {
          console.error(error);
        });
    },
    async loadState(survey) {
      //read user response from the dynamodb table and load it to local state.
      var res = {};
      axios
        .post("/api/assessment/user/response/", {
          network_uuid: this.$store.getters.getUser.network_uuid,
          assessmentKey: this.$route.params.toolKey,
        })
        .then((response) => {
          if (response.data.Count != 0) {
            res = response.data.Items[0].answers;
            survey.currentPageNo = 0;
            // if (res.progress == 100) {
            //   //completed survey, show goto page directly
            //   //setupPageSelector(survey, index);
            //   survey.currentPageNo = 0;
            // } else {
            //   //Set the loaded data into the survey.
            //   if (res.currentPageNo) {
            //     survey.currentPageNo = res.currentPageNo;
            //   }
            // }
          } else {
            res = {
              currentPageNo: 0,
            };
          }
          if (res.data && this.$route.params.toolKey === res.key) {
            survey.data = res.data;
          }
        });
    },
    async saveState(survey) {
      if (!this.isScoping) {
        var unordered = survey.data;
        survey.data = Object.keys(unordered)
          .sort()
          .reduce((obj, key) => {
            obj[key] = unordered[key];
            return obj;
          }, {});
        var yesCount = 0;
        var noCount = 0;
        var answerLaterCount = 0;
        var notApplicableCount = 0;

        $.each(survey.data, function (questionName, choice) {
          //Q1: [object Object]

          if (typeof choice == "object" && Object.keys(choice).length != 0) {
            //$.each(choice, function (n, choiceItem) {
            $.each(choice, function (choiceQuestion, choiceAnswer) {
              // Check if a choiceQuestion exists in the subQuestionList. array.
              if (
                subQuestionList.hasOwnProperty(choiceQuestion) &&
                subQuestionList[choiceQuestion] == questionName
              ) {
                var a = choiceAnswer.answer;
                if (Number.isInteger(a)) {
                  if (a > 0) {
                    yesCount++;
                  } else if (a == 0) {
                    noCount++;
                  } else if (a == -1) {
                    notApplicableCount++;
                  } else {
                    answerLaterCount++;
                  }
                } else {
                  answerLaterCount++;
                }
              }
              else {
                delete choice[choiceQuestion]
              }
            });
          }
          
        });
        var length = 0;
        survey.getAllQuestions().forEach(function (question) {
          if (question.isVisible && question.getType() != "html") {
            length += 1;
          }
        });
        var count = 0;
        survey.getAllQuestions().forEach(function (question) {
          if (!question.isEmpty() && question.isVisible && question.getType() != "html") {
            count += 1;
          }
        });
        survey.data = Object.fromEntries(
          Object.entries(survey.data).filter(([_, value]) => Object.keys(value).length !== 0)
        );
        var res = {
          currentPageNo: survey.currentPageNo,
          data: survey.data,
        };
        var SurveyAnswersObj = {};
        SurveyAnswersObj = res;
        SurveyAnswersObj.email = this.$store.getters.getUser.email;
        SurveyAnswersObj.network_uuid = this.$store.getters.getUser.network_uuid;
        SurveyAnswersObj.key = this.$route.params.toolKey;
        if (count == length && answerLaterCount == 0) {
          //assessment complete

          // if user is only reviewing a completed assessment, and leaves assessment, we still need to calculate score
          SurveyAnswersObj.progress = 100;
          this.progress = 100;
          axios
            .post("/api/assessment/complete/", SurveyAnswersObj)
            .then((response) => {
              if (_this.completeButtonClicked) {
                //complete button clicked, so proceed to build print and export data.
                //PRINT DIV
                var div = document.getElementById("printDiv");
                div.innerHTML = "";
                div.innerHTML +=
                  "<input type='button' value='Print Answers' style='float: right' id='printPage' />";
                div.innerHTML +=
                  "<p> <strong>" + this.schema.title + "</strong></p> ";
                div.innerHTML +=
                  "<p> <strong>Date:</strong> " +
                  this.getFormattedDate(new Date()) +
                  "</p>";

                //EXPORT DATA
                let data = [];
                data.push(["Assessment", this.schema.title]);
                data.push(["Date", this.getFormattedDate(new Date())]);
                if (!(this.$route.params.toolKey.indexOf('SCOPING') > 0)) {
                  if (this.$route.params.toolKey === "NEWNIST800171") {
                    this.isNIST = true;
                    if (response.data.specialMessage == "") {
                      this.score = response.data.nistScore;
                      //export data
                      data.push(["Score", response.data.nistScore]);
                      div.innerHTML +=
                        "<p> <strong>Score:</strong>" +
                        response.data.nistScore +
                        "/110 </p>";
                      this.completeText = "NIST 800-171 provides agencies with recommended security requirements for protecting the  confidentiality of CUI and applies to all components of nonfederal systems and organizations that process, store, and/or transmit CUI.";

                    }
                    else {
                      this.score = "N/A";
                      div.innerHTML +=
                        "<p> <strong>Score:</strong> N/A </p>";
                      this.completeText = response.data.specialMessage;
                      this.missingSecurityplan = true;
                    }
                  }
                  else if (this.$route.params.toolKey === "NEWCMMCLEVEL2") {
                    if (response.data.specialMessage == "") {
                      //export data
                      this.score = response.data.score;
                      //export data
                      data.push(["Score", response.data.score + "%"]);
                      div.innerHTML +=
                        "<p> <strong>Score:</strong>" +
                        response.data.score +
                        "% </p>";
                      this.completeText = "CMMC Level 2 focuses on the protection of CUI and encompasses the 110 security requirements specified in NIST SP 800-171 Rev 2.";

                    }
                    else {
                      this.score = "N/A";
                      data.push(["Score", "N/A"]);
                      div.innerHTML +=
                        "<p> <strong>Score:</strong> N/A </p>";
                      this.completeText = response.data.specialMessage;
                      this.missingSecurityplan = true;
                    }

                  }
                  else {
                    this.completeText = "CMMC Level 1 focuses on the protection of FCI and consists of only practices that correspond to the basic safeguarding requirements specified in 48 CFR 52.204-21, commonly referred to as the FAR Clause.";
                    this.score = response.data.score;
                    //export data
                    data.push(["Score", response.data.score + "%"]);
                    div.innerHTML +=
                      "<p> <strong>Score:</strong>" +
                      response.data.score +
                      "% </p>";
                  }


                }
                else {
                  this.completeText = "Scoping assessment completed."
                }
                if (!(this.$route.params.toolKey.indexOf('SCOPING') > 0)) {
                  //EXPORT DATA
                  data.push([""]);
                  data.push([""]);
                  data.push([
                    "Control",
                    "Primary Questions",
                    "Sub Questions",
                    "Answers",
                  ]);
                  $.each(survey.data, function (primary_question, value) {
                    //building print page results
                    if (questionNameTitleMap[primary_question]) {
                      div.innerHTML +=
                        "<br/><hr/><br/><p style='font-weight:bold'>" +
                        primary_question +
                        ". " +
                        questionNameTitleMap[primary_question] +
                        "</p>";
                    }
                    $.each(value, function (sub_question, answer) {
                      //PRINT DIV
                      div.innerHTML +=
                        "<p>" + sub_question + ":"
                        + (answer["answer"] == 1
                          ? "Yes"
                          : answer["answer"] == 0
                            ? "No"
                            : "Not Applicable") + "</p>";
                      //EXPORT
                      var object = [
                        primary_question,
                        questionNameTitleMap[primary_question],
                        sub_question,
                        answer["answer"] == 1
                          ? "Yes"
                          : answer["answer"] == 0
                            ? "No"
                            : "Not Applicable",
                      ];
                      data.push(object);
                    });
                  });
                  this.surveyCSV = data;
                }
                this.isSurveyComplete = true;
                this.isSurveyPartial = false;
                this.isLoading = false;
                // var div = document.getElementById("surveyComplete");
                // div.innerHTML = "";
                // div.innerHTML += "<p>Your cyber readiness check is complete!</p>";
                // div.innerHTML +=
                //   "<p> <strong>Date:</strong> " + moment().format("LL") + "</p>";
                // if (this.$route.params.toolKey === "NEWNIST800171") {
                //   div.innerHTML +=
                //     "<p> <strong>Score:</strong>" +
                //     response.data.nistScore +
                //     "/110" +
                //     "</p>";
                // } else {
                //   div.innerHTML +=
                //     "<p> <strong>Score:</strong>" +
                //     response.data.score +
                //     "%" +
                //     "</p>";
                // }
              }

            });
        } else {
          //assessment not complete - save partial information
          SurveyAnswersObj.progress = Math.floor(
            ((yesCount + noCount + notApplicableCount) / questionTotalCount) * 100
          );
          this.progress = SurveyAnswersObj.progress;
          axios
            .post("/api/assessment/partial/", SurveyAnswersObj)
            .then((response) => {
              this.isLoading = false;
              this.isSurveyPartial = true;
              this.isSurveyComplete = false;
            });
        }
      }
      else {
        var unordered = survey.data;
        survey.data = Object.keys(unordered)
          .sort()
          .reduce((obj, key) => {
            obj[key] = unordered[key];
            return obj;
          }, {});
        var res = {
          currentPageNo: survey.currentPageNo,
          data: survey.data,
        };
        var SurveyAnswersObj = {};
        SurveyAnswersObj = res;
        SurveyAnswersObj.email = this.$store.getters.getUser.email;
        SurveyAnswersObj.network_uuid = this.$store.getters.getUser.network_uuid;
        SurveyAnswersObj.key = this.$route.params.toolKey;

        //assessment complete

        // if user is only reviewing a completed assessment, and leaves assessment, we still need to calculate score
        SurveyAnswersObj.progress = 100;
        this.progress = 100;


        this.progress = SurveyAnswersObj.progress;
        axios
          .post("/api/assessment/partial/", SurveyAnswersObj)
          .then((response) => {

            if (_this.completeButtonClicked) {

              this.completeText = "Scoping assessment completed."

              this.isSurveyComplete = true;
              this.isSurveyPartial = false;
            }
            else {
              this.isSurveyPartial = true;
              this.isSurveyComplete = false;
            }

            this.isLoading = false;
          });

      }

    },
    buildQuestionNameTitleMap(schema, tool) {
      questionTotalCount = 0;
      for (var i = 0; i < schema.pages.length; i++) {
        //console.log(schema.pages[i].title);
        var elements = schema.pages[i].elements;
        if (!(tool.indexOf('SCOPING') > 0)) {
          for (var j = 0; j < elements.length; j++) {
            if (elements[j].type != "html") {
              questionNameTitleMap[elements[j].name] = elements[j].title; // setting the map
              questionTotalCount = questionTotalCount + elements[j].rows.length; // we calculate questionCount , so we can track progress % when user saves a uncompleted assessment
              // we have to track individual sub questions, so we can load the correct user response data  from DB. Incase the schema questions changed, we have to lose all unwanted response data saved.
              elements[j].rows.forEach(function (row) {
                //console.log(row);
                subQuestionList[row] = elements[j].name;
              });
            }
          }
        }
        else {
          questionTotalCount = questionTotalCount + elements.length
        }

        if (i == schema.pages.length - 1) {
          //console.log("calculated questionTotalCount", questionTotalCount);
          return;
        }
      }
    },
    getFormattedDate(date) {
      var year = date.getFullYear();
      var month = (1 + date.getMonth()).toString();
      month = month.length > 1 ? month : "0" + month;
      var day = date.getDate().toString();
      day = day.length > 1 ? day : "0" + day;
      return month + "/" + day + "/" + year;
    },
  },
};
</script>

<style>
.survey-video {
  cursor: pointer;
  display: inline-block;
  position: relative;
  border-bottom: 1px dotted #666;
  text-align: left;
  margin: 20px 0 0 10px;
}

.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .3s ease;
}

.modal-header {
  border: none !important;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

#printDiv {
  display: none;
}

.sv_matrix_row td:nth-child(even) {
  width: 40% !important;
}

.sv_matrix_row td:nth-child(odd) {
  width: 60% !important;
}

.sv_progress-buttons__list li::after {
  width: 55% !important;
  height: 3px;
  content: "";
  position: absolute;
  top: 15px;
  left: -27.5% !important;
}

.sv_progress-buttons__list li {
  width: 4em !important;
}

.breadcrumb-small-content {
  min-height: 250px !important;
}

.rightArrow {
  border: solid black;
  border-width: 0 3px 3px 0;
  display: inline-block;
  padding: 3px;
  transform: rotate(-45deg);
  -webkit-transform: rotate(-45deg);
}

.leftLine {
  border-left: solid black;
  border-width: 0 3px 3px 0;
  display: inline-block;
  padding-left: 15px;
}

.survey-tooltip {
  display: inline-block;
  position: relative;
  border-bottom: 1px dotted #666;
  text-align: left;
  margin: 20px 0 0 10px;
  cursor: pointer;
}

.survey-tooltip .right {
  min-width: 400px;
  top: 50%;
  left: 100%;
  margin-left: 10px;
  transform: translate(0, -50%);
  padding: 10px 20px;
  color: #444444;
  background-color: #eeeeee;
  font-weight: normal;
  font-size: 15px;
  border-radius: 8px;
  position: absolute;
  z-index: 99999999;
  box-sizing: border-box;
  box-shadow: 0 1px 8px rgba(0, 0, 0, 0.5);
  visibility: hidden;
  opacity: 0;
  transition: opacity 0.8s;
}

.survey-tooltip:hover .right {
  visibility: visible;
  opacity: 1;
}

.survey-tooltip .right i {
  position: absolute;
  top: 50%;
  right: 100%;
  margin-top: -12px;
  width: 12px;
  height: 24px;
  overflow: hidden;
}

.survey-tooltip .right i::after {
  content: "";
  position: absolute;
  width: 12px;
  height: 12px;
  left: 0;
  top: 50%;
  transform: translate(50%, -50%) rotate(-45deg);
  background-color: #eeeeee;
  box-shadow: 0 1px 8px rgba(0, 0, 0, 0.5);
}

/* .survey-tooltip span {
    display: none;
    color: #314584;
  }
 
  .survey-tooltip:hover span {
    border: #c0c0c0 1px dotted;
    padding: 5px 20px 5px 5px;
    display: block;
    z-index: 100;
    background: #f0f0f0 no-repeat 100% 5%;
    left: 0px;
    margin: 10px;
    width: 250px;
    position: absolute;
    top: 10px;
    text-decoration: none
  } */
.breadcrumb-content {
  min-height: 250px !important;
}

.surveyDiv {
  margin-top: 1em !important;
}

.sv_q_title {
  color: #314584;
}

.sv_window {
  position: fixed;
  bottom: 3px;
  right: 10px;
  background-color: cadetblue;
  padding: 1px;
  font-family: "Rajdhani", sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 1.42857143;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  word-spacing: normal;
  word-wrap: normal;
  white-space: normal;
  background-color: #fff;
  -webkit-background-clip: padding-box;
  background-clip: padding-box;
  border: 1px solid #ccc;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 6px;
  -webkit-box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2);
  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2);
  line-break: auto;
}

.sv_window_title {
  padding: 8px 14px;
  margin: 0;
  font-size: 14px;
  background-color: #f7f7f7;
  border-bottom: 1px solid #ebebeb;
  border-radius: 5px 5px 0 0;
}

.sv_window_content {
  padding: 8px;
  margin: 0;
}

.sv_window_title a,
.sv_window_title a:link,
.sv_window_title a:visited {
  text-decoration: none;
  font-size: 14px;
  font-style: normal;
  color: black;
}

.sv_main.sv_frame .sv_container {
  max-width: 80%;
  margin: auto;
  padding: 0 1em;
}

.sv_main.sv_frame .sv_container .sv_header {
  padding-top: 5em;
  padding-bottom: 1em;
}

.sv_main {
  /* background-color: #f4f4f4; */
}

.sv_main hr {
  border-bottom: 1px solid #e7e7e7;
}

.sv_main input[type="button"],
.sv_main button {
  color: 444;
  background-color: #678d9e;
}

.sv_main input[type="button"]:hover,
.sv_main button:hover {
  background-color: #007bff;
}

.sv_main .sv_q_other input,
.sv_main .sv_q_text_root,
.sv_main .sv_q_dropdown_control,
.sv_main input:not([type="button"]):not([type="reset"]):not([type="submit"]):not([type="image"]):not([type="checkbox"]):not([type="radio"]),
.sv_main select,
.sv_main textarea {
  border: 1px solid #e7e7e7;
  color: #6d7072;
  background-color: white;
}

.sv_main .sv_q_other input:focus,
.sv_main .sv_q_text_root:focus,
.sv_main .sv_q_dropdown_control:focus,
.sv_main input:not([type="button"]):not([type="reset"]):not([type="submit"]):not([type="image"]):not([type="checkbox"]):not([type="radio"]):focus,
.sv_main select:focus,
.sv_main textarea:focus {
  border: 1px solid #678d9e;
}

.sv_main .sv_select_wrapper {
  background-color: white;
}

.sv_main .sv_select_wrapper:before {
  background-color: #678d9e;
}

.sv_main .sv_header {
  color: #6d7072;
}

.sv_main .sv_custom_header {
  background-color: #e7e7e7;
}

.sv_main .sv_container {
  /* color: #6d7072;  */
}

.sv_main .sv_body {
  background-color: white;
}

.sv_main .sv_progress {
  background-color: #e7e7e7;
  margin-bottom: 3em;
}

.sv_main .sv_progress_bar {
  background-color: #678d9e;
}

.sv_main .sv_p_root>.sv_row {
  border-bottom: 1px solid #808080;
}

.sv_main .sv_p_root>.sv_row:nth-child(odd) {
  background-color: white;
}

.sv_main .sv_p_root>.sv_row:nth-child(even) {
  /* background-color: #f4f4f4; */
}

.sv_main .sv_q_erbox:not([style*="display: none"]):not([style*="display:none"]) {
  border: 1px solid #ed5565;
  /*background-color: #fcdfe2;*/
  color: #ed5565;
}

.sv_main .sv_q_erbox:not([style*="display: none"]):not([style*="display:none"])+input,
.sv_main .sv_q_erbox:not([style*="display: none"]):not([style*="display:none"])+textarea,
.sv_main .sv_q_erbox:not([style*="display: none"]):not([style*="display:none"])+.sv_select_wrapper select {
  border: 1px solid #ed5565;
}

.sv_main .sv_q_erbox:not([style*="display: none"]):not([style*="display:none"])+input:focus,
.sv_main .sv_q_erbox:not([style*="display: none"]):not([style*="display:none"])+textarea:focus,
.sv_main .sv_q_erbox:not([style*="display: none"]):not([style*="display:none"])+.sv_select_wrapper select:focus {
  outline: #ed5565 auto 5px;
}

.sv_main table.sv_q_matrix tr,
.sv_main table.sv_q_matrix_dropdown tr,
.sv_main table.sv_q_matrix_dynamic tr {
  /* border-bottom: 1px solid #e7e7e7; */
}

.sv_main .sv_q_m_cell_selected {
  color: white;
  background-color: #179d82;
}

.sv_main .sv_q_rating_item.active .sv_q_rating_item_text {
  background-color: #179d82;
  border-color: #179d82;
  color: white;
}

.sv_main .sv_q_rating_item .sv_q_rating_item_text {
  border: 1px solid #e7e7e7;
}

.sv_main .sv_q_rating_item .sv_q_rating_item_text:hover {
  border: 1px solid #179d82;
}

.sv_main .sv_q_imgsel.checked label>div {
  background-color: #678d9e;
}

.sv_main .sv_q_file_remove:hover {
  color: #678d9e;
}

.sv_main {
  position: relative;
  width: 100%;
  font-family: "Rajdhani", sans-serif;
  font-size: 1rem;
}

.sv_main hr {
  border: none;
}

.sv_main input[type="button"],
.sv_main button {
  font-size: 0.85em;
  font-weight: bold;
  line-height: 2em;
  border: none;
  min-width: 100px;
  cursor: pointer;
  padding: 0 2em;
  border-radius: 2px;
}

.sv_main .sv_custom_header {}

.sv_main .sv_container {
  position: relative;
}

.sv_main .sv_container .sv_header {
  padding: 1em;
}

.sv_main .sv_container .sv_header h3 {
  font-size: 2em;
  font-weight: 300;
  text-align: left;
  margin: 0;
}

.sv_main .sv_container .sv_body {
  padding: 1em 1em 1.6428em 1em;
}

.sv_main .sv_container .sv_body.sv_completed_page {
  text-align: center;
  padding: 5em 1em;
}

.sv_main .sv_container .sv_body.sv_completed_page>h3 {
  margin: 0;
  font-size: 30px;
  font-weight: 300;
}

.sv_main .sv_container .sv_body .sv_progress {
  height: 0.5em;
}

.sv_main .sv_container .sv_body .sv_progress .sv_progress_bar {
  height: 100%;
  min-width: 100px;
  position: relative;
}

.sv_main .sv_container .sv_body .sv_progress .sv_progress_bar>span {
  position: absolute;
  top: -1.5em;
  display: inline-block;
  white-space: nowrap;
}

.sv_main .sv_container .sv_body .sv_p_root .sv_page_title {
  font-size: 1em;
  margin-top: 0.1em;
  font-weight: bold;
}

.sv_main .sv_container .sv_body .sv_p_root .sv_p_title {
  font-weight: bold;
  font-size: 1.15em;
  margin: 1.5em 0 0 0;
}

.sv_main .sv_container .sv_body .sv_p_root>.sv_row {
  padding: 0;
}

.sv_main .sv_container .sv_body .sv_p_root .sv_q_title {
  font-weight: bold;
  font-size: 1em;
  margin: 0.5em 0;
}

.sv_main .sv_container .sv_body .sv_p_root .sv_q_description {
  margin-top: -0.6em;
  min-height: 0.6em;
}

.sv_main .sv_container .sv_body .sv_p_root .sv_q_flow .sv_q_checkbox_inline,
.sv_main .sv_container .sv_body .sv_p_root .sv_q_flow .sv_q_radiogroup_inline,
.sv_main .sv_container .sv_body .sv_p_root .sv_q_flow .sv_q_imagepicker_inline {
  line-height: 2em;
  display: inline-block;
}

.sv_main .sv_container .sv_body .sv_p_root .sv_q {
  padding: 0.5em 1em 1.5em 1em;
  box-sizing: border-box;
  overflow: auto;
}

.sv_main .sv_container .sv_body .sv_p_root .sv_q .sv_panel_dynamic .sv_q_title {
  font-weight: normal;
}

.sv_main .sv_container .sv_body .sv_p_root .sv_q .sv_panel_dynamic .sv-paneldynamic__progress-container {
  position: relative;
  margin-right: 250px;
  margin-left: 40px;
  margin-top: 10px;
}

.sv_main .sv_container .sv_body .sv_p_root .sv_q .sv_q_erbox:not([style*="display: none"]):not([style*="display:none"]) {
  margin: 0.5em 0;
  padding: 0.5em;
}

.sv_main .sv_container .sv_body .sv_p_root .sv_q .sv_q_other input,
.sv_main .sv_container .sv_body .sv_p_root .sv_q .sv_q_text_root,
.sv_main .sv_container .sv_body .sv_p_root .sv_q .sv_q_dropdown_control,
.sv_main .sv_container .sv_body .sv_p_root .sv_q input:not([type="button"]):not([type="reset"]):not([type="submit"]):not([type="image"]):not([type="checkbox"]):not([type="radio"]),
.sv_main .sv_container .sv_body .sv_p_root .sv_q select,
.sv_main .sv_container .sv_body .sv_p_root .sv_q textarea {
  position: relative;
  width: 100%;
  box-sizing: border-box;
  font-size: 1em;
  line-height: 2em;
  padding-left: 1em;
}

.sv_main .sv_container .sv_body .sv_p_root .sv_q .sv_q_other input:focus,
.sv_main .sv_container .sv_body .sv_p_root .sv_q .sv_q_text_root:focus,
.sv_main .sv_container .sv_body .sv_p_root .sv_q .sv_q_dropdown_control:focus,
.sv_main .sv_container .sv_body .sv_p_root .sv_q input:not([type="button"]):not([type="reset"]):not([type="submit"]):not([type="image"]):not([type="checkbox"]):not([type="radio"]):focus,
.sv_main .sv_container .sv_body .sv_p_root .sv_q select:focus,
.sv_main .sv_container .sv_body .sv_p_root .sv_q textarea:focus {
  outline: none;
}

.sv_main .sv_container .sv_body .sv_p_root .sv_q .sv_q_other input,
.sv_main .sv_container .sv_body .sv_p_root .sv_q .sv_q_dropdown_control,
.sv_main .sv_container .sv_body .sv_p_root .sv_q input:not([type="button"]):not([type="reset"]):not([type="submit"]):not([type="image"]):not([type="checkbox"]):not([type="radio"]),
.sv_main .sv_container .sv_body .sv_p_root .sv_q select {
  height: calc(2em + 1px);
}

.sv_main .sv_container .sv_body .sv_p_root .sv_q div.sv_q_text_root,
.sv_main .sv_container .sv_body .sv_p_root .sv_q div.sv_q_dropdown_control {
  min-height: 2.43em;
  min-width: 7em;
}

.sv_main .sv_container .sv_body .sv_p_root .sv_q .sv_select_wrapper {
  width: 100%;
  position: relative;
  display: inline-block;
}

.sv_main .sv_container .sv_body .sv_p_root .sv_q .sv_select_wrapper select {
  display: block;
  background: transparent;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  padding-right: 2.5em;
  min-width: 15em;
}

.sv_main .sv_container .sv_body .sv_p_root .sv_q .sv_select_wrapper select::-ms-expand {
  display: none;
}

.sv_main .sv_container .sv_body .sv_p_root .sv_q .sv_select_wrapper:before {
  padding: 1em;
  position: absolute;
  right: 1px;
  right: 0;
  top: 1px;
  background-image: url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDIxLjEuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHZpZXdCb3g9IjAgMCAzNCAzNCIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgMzQgMzQ7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4KPHN0eWxlIHR5cGU9InRleHQvY3NzIj4KCS5zdDB7ZmlsbDojRkZGRkZGO30KPC9zdHlsZT4KPHBvbHlnb24gY2xhc3M9InN0MCIgcG9pbnRzPSIxMiwxNiAxNCwxNCAxNywxNyAyMCwxNCAyMiwxNiAxNywyMSAiLz4KPC9zdmc+Cg==);
  content: "";
  background-repeat: no-repeat;
  background-position: center;
}

.sv_main .sv_container .sv_body .sv_p_root .sv_q input[type="color"] {
  min-height: 2em;
  padding: 0;
}

.sv_main .sv_container .sv_body .sv_p_root .sv_q input[type="radio"],
.sv_main .sv_container .sv_body .sv_p_root .sv_q input[type="checkbox"] {
  margin: 0;
  margin-right: 0.55em;
  width: 1.2em;
  height: 1.2em;
  vertical-align: middle;
  font-size: 1em;
  margin-top: -0.1em;
}

.sv_main .sv_container .sv_body .sv_p_root .sv_q input[type="radio"]:focus,
.sv_main .sv_container .sv_body .sv_p_root .sv_q input[type="checkbox"]:focus {
  outline: 1px dotted #678d9e;
}

.sv_main .sv_container .sv_body .sv_p_root .sv_q .sv_q_radiogroup.sv_q_radiogroup_inline:not(:last-child),
.sv_main .sv_container .sv_body .sv_p_root .sv_q .sv_q_checkbox.sv_q_checkbox_inline:not(:last-child),
.sv_main .sv_container .sv_body .sv_p_root .sv_q .sv_q_imgsel.sv_q_imagepicker_inline:not(:last-child) {
  margin-right: 1.5em;
}

.sv_main .sv_container .sv_body .sv_p_root .sv_q .sv_q_imgsel label>div {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  padding: 4px;
  border: 1px solid lightgray;
  border-radius: 4px;
}

.sv_main .sv_container .sv_body .sv_p_root .sv_q .sv_q_imgsel label>div>img {
  display: block;
  pointer-events: none;
  position: relative;
}

.sv_main .sv_container .sv_body .sv_p_root .sv_q .sv_q_radiogroup_clear {
  margin-top: 0.5em;
}

.sv_main .sv_container .sv_body .sv_p_root .sv_q .sv_q_checkbox_inline,
.sv_main .sv_container .sv_body .sv_p_root .sv_q .sv_q_radiogroup_inline,
.sv_main .sv_container .sv_body .sv_p_root .sv_q .sv_q_imagepicker_inline {
  line-height: 2em;
  display: inline-block;
}

.sv_main .sv_container .sv_body .sv_p_root .sv_q .sv_q_footer {
  padding: 1em 0;
}

.sv_main .sv_container .sv_body .sv_p_root table {
  width: 100%;
  border-collapse: collapse;
}

.sv_main .sv_container .sv_body .sv_p_root table.sv_q_matrix .sv_matrix_dynamic_button,
.sv_main .sv_container .sv_body .sv_p_root table.sv_q_matrix_dropdown .sv_matrix_dynamic_button,
.sv_main .sv_container .sv_body .sv_p_root table.sv_q_matrix_dynamic .sv_matrix_dynamic_button {
  padding: 0.3em 2em;
}

@media (min-width: 768px) {
  .sv_main .sv_container .sv_body .sv_p_root table.sv_q_matrix td {
    min-width: 10em;
  }
}

.sv_main .sv_container .sv_body .sv_p_root table.sv_q_matrix td .sv_q_m_label {
  position: static;
  display: block;
  width: 100%;
}

.sv_main .sv_container .sv_body .sv_p_root table.sv_q_matrix_dropdown .sv_qcbc .sv_q_checkbox_control_label {
  margin-right: 1.5em;
}

.sv_main .sv_container .sv_body .sv_p_root table td,
.sv_main .sv_container .sv_body .sv_p_root table th {
  text-align: left;
  padding: 0 1em;
}

.sv_main .sv_container .sv_body .sv_p_root table td {
  padding: 0.2em;
}

.sv_main .sv_container .sv_body .sv_p_root table th {
  line-height: 1.3em;
  padding: 0.5em;
  vertical-align: bottom;
  font-weight: bold;
  display: none;
}

.sv_main .sv_container .sv_body .sv_p_root fieldset.sv_qcbc {
  line-height: 2em;
  padding-top: 0.1em;
}

.sv_main .sv_container .sv_body .sv_p_root .sv_q_other {
  margin-left: 1em;
}

.sv_main .sv_container .sv_body .sv_p_root .sv_q_select_column {
  display: inline-block;
  vertical-align: top;
  min-width: 10%;
}

.sv_main .sv_container .sv_body .sv_p_root .sv_q_rating {
  line-height: 2em;
}

.sv_main .sv_container .sv_body .sv_p_root .sv_q_rating .sv_q_rating_item {
  cursor: pointer;
  word-spacing: -0.3em;
  font-weight: normal;
  display: inline;
}

.sv_main .sv_container .sv_body .sv_p_root .sv_q_rating .sv_q_rating_item>* {
  word-spacing: initial;
}

@media all and (-ms-high-contrast: none),
(-ms-high-contrast: active) {
  .sv_main .sv_container .sv_body .sv_p_root .sv_q_rating .sv_q_rating_item>* {
    word-spacing: normal;
  }
}

.sv_main .sv_container .sv_body .sv_p_root .sv_q_rating .sv_q_rating_item .sv_q_rating_item_text {
  display: inline-block;
  min-width: 2em;
  padding: 0 0.3em;
  margin-left: -1px;
  text-align: center;
}

.sv_main .sv_container .sv_body .sv_p_root .sv_q_rating .sv_q_rating_item:not(:first-child) .sv_q_rating_item_text:not(:hover) {
  border-left-color: transparent;
}

.sv_main .sv_container .sv_body .sv_p_root .sv_q_rating .sv_q_rating_min_text {
  margin-right: 0.5em;
}

.sv_main .sv_container .sv_body .sv_p_root .sv_q_rating .sv_q_rating_max_text {
  margin-left: 0.5em;
}

.sv_main .sv_container .sv_body .sv_nav {
  padding: 1em 0;
  min-height: 2em;
}

.sv_main .sv_container .sv_body .sv_nav .sv_start_btn,
.sv_main .sv_container .sv_body .sv_nav .sv_next_btn,
.sv_main .sv_container .sv_body .sv_nav .sv_complete_btn {
  float: right;
}

.sv_main .sv_container .sv_body .sv_nav .sv_prev_btn {
  float: left;
}

@media (max-width: 600px) {

  .sv_main .sv_container .sv_body .sv_p_root .sv_row .sv_q,
  .sv_main .sv_container .sv_body .sv_p_root .sv_row .sv_qstn {
    display: block;
    width: 100% !important;
  }

  .sv_main .sv_container .sv_body .sv_p_root .sv_row .sv_q .title-left,
  .sv_main .sv_container .sv_body .sv_p_root .sv_row .sv_qstn .title-left {
    float: none;
  }

  .sv_main .sv_container .sv_body .sv_p_root .sv_row .sv_q .sv_q_radiogroup_inline,
  .sv_main .sv_container .sv_body .sv_p_root .sv_row .sv_q .sv_q_checkbox_inline,
  .sv_main .sv_container .sv_body .sv_p_root .sv_row .sv_q .sv_q_imagepicker_inline,
  .sv_main .sv_container .sv_body .sv_p_root .sv_row .sv_qstn .sv_q_radiogroup_inline,
  .sv_main .sv_container .sv_body .sv_p_root .sv_row .sv_qstn .sv_q_checkbox_inline,
  .sv_main .sv_container .sv_body .sv_p_root .sv_row .sv_qstn .sv_q_imagepicker_inline {
    display: block;
  }

  .sv_main .sv_container .sv_body .sv_p_root .sv_row .sv_q table.sv_q_matrix,
  .sv_main .sv_container .sv_body .sv_p_root .sv_row .sv_q table.sv_q_matrix_dropdown,
  .sv_main .sv_container .sv_body .sv_p_root .sv_row .sv_q table.sv_q_matrix_dynamic,
  .sv_main .sv_container .sv_body .sv_p_root .sv_row .sv_qstn table.sv_q_matrix,
  .sv_main .sv_container .sv_body .sv_p_root .sv_row .sv_qstn table.sv_q_matrix_dropdown,
  .sv_main .sv_container .sv_body .sv_p_root .sv_row .sv_qstn table.sv_q_matrix_dynamic {
    display: block;
  }

  .sv_main .sv_container .sv_body .sv_p_root .sv_row .sv_q table.sv_q_matrix thead,
  .sv_main .sv_container .sv_body .sv_p_root .sv_row .sv_q table.sv_q_matrix_dropdown thead,
  .sv_main .sv_container .sv_body .sv_p_root .sv_row .sv_q table.sv_q_matrix_dynamic thead,
  .sv_main .sv_container .sv_body .sv_p_root .sv_row .sv_qstn table.sv_q_matrix thead,
  .sv_main .sv_container .sv_body .sv_p_root .sv_row .sv_qstn table.sv_q_matrix_dropdown thead,
  .sv_main .sv_container .sv_body .sv_p_root .sv_row .sv_qstn table.sv_q_matrix_dynamic thead {
    display: none;
  }

  .sv_main .sv_container .sv_body .sv_p_root .sv_row .sv_q table.sv_q_matrix tbody,
  .sv_main .sv_container .sv_body .sv_p_root .sv_row .sv_q table.sv_q_matrix tr,
  .sv_main .sv_container .sv_body .sv_p_root .sv_row .sv_q table.sv_q_matrix td,
  .sv_main .sv_container .sv_body .sv_p_root .sv_row .sv_q table.sv_q_matrix_dropdown tbody,
  .sv_main .sv_container .sv_body .sv_p_root .sv_row .sv_q table.sv_q_matrix_dropdown tr,
  .sv_main .sv_container .sv_body .sv_p_root .sv_row .sv_q table.sv_q_matrix_dropdown td,
  .sv_main .sv_container .sv_body .sv_p_root .sv_row .sv_q table.sv_q_matrix_dynamic tbody,
  .sv_main .sv_container .sv_body .sv_p_root .sv_row .sv_q table.sv_q_matrix_dynamic tr,
  .sv_main .sv_container .sv_body .sv_p_root .sv_row .sv_q table.sv_q_matrix_dynamic td,
  .sv_main .sv_container .sv_body .sv_p_root .sv_row .sv_qstn table.sv_q_matrix tbody,
  .sv_main .sv_container .sv_body .sv_p_root .sv_row .sv_qstn table.sv_q_matrix tr,
  .sv_main .sv_container .sv_body .sv_p_root .sv_row .sv_qstn table.sv_q_matrix td,
  .sv_main .sv_container .sv_body .sv_p_root .sv_row .sv_qstn table.sv_q_matrix_dropdown tbody,
  .sv_main .sv_container .sv_body .sv_p_root .sv_row .sv_qstn table.sv_q_matrix_dropdown tr,
  .sv_main .sv_container .sv_body .sv_p_root .sv_row .sv_qstn table.sv_q_matrix_dropdown td,
  .sv_main .sv_container .sv_body .sv_p_root .sv_row .sv_qstn table.sv_q_matrix_dynamic tbody,
  .sv_main .sv_container .sv_body .sv_p_root .sv_row .sv_qstn table.sv_q_matrix_dynamic tr,
  .sv_main .sv_container .sv_body .sv_p_root .sv_row .sv_qstn table.sv_q_matrix_dynamic td {
    display: block;
  }

  .sv_main .sv_container .sv_body .sv_p_root .sv_row .sv_q table.sv_q_matrix_dropdown td:before,
  .sv_main .sv_container .sv_body .sv_p_root .sv_row .sv_q table.sv_q_matrix_dynamic td:before,
  .sv_main .sv_container .sv_body .sv_p_root .sv_row .sv_qstn table.sv_q_matrix_dropdown td:before,
  .sv_main .sv_container .sv_body .sv_p_root .sv_row .sv_qstn table.sv_q_matrix_dynamic td:before {
    content: attr(headers);
  }

  .sv_main .sv_container .sv_body .sv_p_root .sv_row .sv_q table.sv_q_matrix td label.sv_q_m_label,
  .sv_main .sv_container .sv_body .sv_p_root .sv_row .sv_qstn table.sv_q_matrix td label.sv_q_m_label {
    display: inline;
  }

  .sv_main .sv_container .sv_body .sv_p_root .sv_row .sv_q table.sv_q_matrix td:after,
  .sv_main .sv_container .sv_body .sv_p_root .sv_row .sv_qstn table.sv_q_matrix td:after {
    content: attr(headers);
  }
}

.sv-hidden {
  display: none;
}

.sv-boolean--indeterminate .sv-boolean__switch {
  background-color: #cdcdcd;
  transition: 0.5s;
}

.sv-boolean__slider {
  background-color: #fff;
}

.sv-boolean--checked .sv-boolean__switch {
  background-color: rgb(121, 173, 163);
}

.sv-boolean__switch {
  background-color: rgb(240, 128, 128);
}

.sv_matrix_cell {
  width: 50%;
}

.sv_main.sv_default_css .sv_p_root>.sv_row:nth-child(2n) {
  background: none !important;
}

.sv_main .sv_container .sv_header h3 {
  font-weight: 400;
}

.v-application a {
  color: white !important;
  padding: 0.5em 0 0 0
}

.sv_progress-buttons__list {
  display: table;
  margin-left: 0;
}

.sv_progress-buttons__list li

/* horizontal menu layout */
  {
  display: inline-block;
  border: 3px solid #FFFFFF;
  border-radius: 10px;
  background-color: lightgrey;
  cursor: pointer;

  font-size: 1em;
  text-align: center;
}

.sv_progress-buttons__list li a:hover

/* link style on-mouse-over */
  {
  color: #FFFFFF;
  text-transform: uppercase;
  text-decoration: none;
}

.sv_progress-buttons__list li:hover

/* button style on-mouse-over */
  {
  border: 3px solid #FFFFFF;
  border-radius: 10px;
  background-color: darkgrey;
}

.redText {
  color: red;
}
</style>
